import { Box } from "@mui/material";
import background from "../../assets/images/logo_home.webp";
import bandPhoto from "../../assets/images/luis_nicolas_tarde.webp";
import { Hero } from "./components/Hero";
import { Highlight } from "./components/Highlight";
import { EventTypes } from "./components/EventTypes";
import { CtaBanner } from "./components/CtaBanner";

export function Home() {
  return (
    <Box component="main" sx={{ overflowX: "hidden" }}>
      <Hero background={background} />
      <Highlight
        image={bandPhoto}
        overline="Dance the night away"
        title="Música ao vivo para momentos inesquecíveis"
        description="A Groowv Electric Band transforma qualquer evento em uma experiência inesquecível."
      />
      <EventTypes />
      <CtaBanner />
    </Box>
  );
}
